import React from 'react';
import { Article, DateAndTime, Document, OnlinePrograms, Order, ProGalleries, SiteContent, User, WixBooking, WixForum } from '@wix/wix-ui-icons-common';
import { Box, CircularProgressBar, Text, Tooltip } from '@wix/design-system';
import { SiteIndexProgressDataHooks } from './site-index-progress.data-hooks';
const docTypes = [{
  type: 'site_pages',
  name: 'Site Pages'
}, {
  type: 'products',
  name: 'Products'
}, {
  type: 'services',
  name: 'Services'
}, {
  type: 'events',
  name: 'Events'
}, {
  type: 'blog_post',
  name: 'Blog Posts'
}, {
  type: 'forum_content',
  name: 'Forum Content'
}, {
  type: 'online_program',
  name: 'Online Programs'
}, {
  type: 'pro_gallery',
  name: 'Pro Gallery'
}, {
  type: 'external',
  name: 'External'
}];
export const getDocName = type => {
  var _docTypes$find;
  return ((_docTypes$find = docTypes.find(doc => doc.type === type)) == null ? void 0 : _docTypes$find.name) ?? 'Others';
};
export const renderDocIcon = type => {
  switch (type) {
    case 'site_pages':
      return /*#__PURE__*/React.createElement(SiteContent, null);
    case 'products':
      return /*#__PURE__*/React.createElement(Order, null);
    case 'services':
      return /*#__PURE__*/React.createElement(WixBooking, null);
    case 'events':
      return /*#__PURE__*/React.createElement(DateAndTime, null);
    case 'blog_post':
      return /*#__PURE__*/React.createElement(Article, null);
    case 'forum_content':
      return /*#__PURE__*/React.createElement(WixForum, null);
    case 'online_program':
      return /*#__PURE__*/React.createElement(OnlinePrograms, null);
    case 'pro_gallery':
      return /*#__PURE__*/React.createElement(ProGalleries, null);
    case 'external':
      return /*#__PURE__*/React.createElement(User, null);
    default:
      return /*#__PURE__*/React.createElement(Document, null);
  }
};
export const renderDocName = type => {
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "left",
    verticalAlign: "middle",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: getDocName(type),
    enterDelay: 500
  }, renderDocIcon(type)), /*#__PURE__*/React.createElement(Text, {
    weight: "normal",
    size: "small",
    dataHook: SiteIndexProgressDataHooks.DocName
  }, getDocName(type)));
};
export const getProgressBarValue = (value, total) => {
  return value / total * 100;
};
export const renderProgressBar = (value, total, rowIndex, reverse) => {
  const perc = getProgressBarValue(value, total);
  return /*#__PURE__*/React.createElement(CircularProgressBar, {
    dataHook: `${SiteIndexProgressDataHooks.ProgressBar}-${rowIndex}`,
    size: "tiny",
    value: perc,
    showProgressIndication: false,
    skin: reverse ? perc < 80 ? 'success' : 'standard' : perc > 80 ? 'success' : 'standard'
  });
};
//# sourceMappingURL=site-index-progress.utilities.js.map